import { Column } from "../Column";

// Frosted reeds along the frozen pond's banks.
const REEDS = [
  { left: "5%", height: "70%", delay: "0s" },
  { left: "8%", height: "92%", delay: "-0.7s" },
  { left: "11%", height: "62%", delay: "-1.4s" },
  { left: "89%", height: "78%", delay: "-2.1s" },
  { left: "93%", height: "58%", delay: "-2.8s" },
];

export const PlayyardPond = () => {
  /* Render */
  const render = () => {
    return (
      <Column
        className="pointer-events-none absolute left-[4%] top-[59%] z-[6] h-[12%] w-[27%] rounded-[50%] shadow-[inset_0_6px_12px_rgb(0_0_0_/_0.25)]"
        style={{
          background:
            "linear-gradient(var(--yard-waterTop), var(--yard-waterBottom))",
          outline: "5px solid var(--yard-groundTop)",
        }}
      >
        <svg
          className="absolute inset-0 h-full w-full overflow-hidden rounded-[50%]"
          viewBox="0 0 270 90"
          preserveAspectRatio="none"
        >
          <path
            d="M-8 60 75 42 120 53 190 20 280 34M75 42 88 16M120 53 142 83M190 20 185 0"
            stroke="#eaf7ff"
            strokeWidth="1.4"
            fill="none"
            opacity="0.65"
          />
          <path
            d="M22 28 92 13M165 67 228 55"
            stroke="#f5fcff"
            strokeWidth="5"
            strokeLinecap="round"
            opacity="0.35"
          />
        </svg>
      </Column>
    );
  };

  return render();
};

export const PlayyardPondPlants = () => {
  /* Render */
  const render = () => {
    return (
      <Column className="pointer-events-none absolute left-[2%] top-[49%] z-[11] h-[11%] w-[31%]">
        {REEDS.map((reed) => (
          <Column
            key={reed.left}
            className="absolute bottom-0 w-[3px] rounded-full bg-[#a7b4bc]"
            style={{
              left: reed.left,
              height: reed.height,
              animationDelay: reed.delay,
            }}
          >
            <Column className="absolute -left-[2px] top-0 h-4 w-[7px] rounded-full border-t-2 border-white bg-[#8c8a87]" />
          </Column>
        ))}
      </Column>
    );
  };

  return render();
};
